module.exports = __webpack_public_path__ + "img/months.0ff9ee20.svg";